var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-booklib-container"},[_c('ListHeader',{staticClass:"books-list-header",attrs:{"listTitle":"我的链接作品"},on:{"query-list":_vm.getBooks}}),_c('LinksPublished',{ref:"LinksPublished",attrs:{"shelfLinkData":_vm.linkData},on:{"changePage":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }